import { SvgIcon } from '@mui/material';
import { ReactComponent as WebLoginJoinIconSVG } from "./web-login-join-iocn.svg";

export default function IconWebLoginJoin(props) {
  return <SvgIcon {...props} component={WebLoginJoinIconSVG} viewBox="0 0 770 830" />;
}